import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button, Badge } from "reactstrap";
import axios from "axios";
import Header from "../../layout/Header/Header";

function BotonesVentas() {
  const { user } = useContext(AuthContext);
  const [pendientesSurtir, setPendientesSurtir] = useState(0);

  // U23: contar pendientes de surtir
  useEffect(() => {
    const URL = process.env.REACT_APP_URL_PEDIDOS;
    if (!URL) return;
    axios
      .get(`${URL}PendienteSurtir`, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => {
        const surtibles = (res.data || []).filter(
          (p) =>
            p.is_active === "Si" &&
            (p.status || "Abierto") === "Abierto" &&
            p.autorizadoSurtido === "Si" &&
            p.surtido !== "Si"
        );
        setPendientesSurtir(surtibles.length);
      })
      .catch(() => setPendientesSurtir(0));
  }, []);

  const Btn = ({ permitido, href, icon, label, badge }) => (
    <Col md={4} align="center">
      {permitido ? (
        <Button href={href} className="botonesMenu" color="success" style={{ position: "relative" }}>
          {badge != null && badge > 0 && (
            <Badge color="danger" style={{ position: "absolute", top: 8, right: 8, fontSize: 14 }}>
              {badge}
            </Badge>
          )}
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      ) : (
        <Button disabled className="botonesMenu" color="success">
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      )}
    </Col>
  );

  const Seccion = ({ titulo }) => (
    <>
      <br />
      <h4 style={{ borderBottom: "2px solid #f28029", paddingBottom: 6, marginBottom: 16, color: "#333" }}>
        {titulo}
      </h4>
    </>
  );

  return (
    <>
      <Header />
      {user.menu_ventas ? (
        <div className="container">
          <br />


          {/* ===== OPERACIÓN ===== */}
          <Seccion titulo="Operación" />
          <Row>
            <Btn permitido={user.menu_pedidos} href="/ListadoPedidos" icon="fa-shopping-basket" label="Cotizaciones" />
            <Btn permitido={user.surtidos_create} href="/ListadoPendienteSurtir" icon="fa-truck-moving" label="Surtir" badge={pendientesSurtir} />
            <Btn permitido={user.menu_surtidos} href="/ListadoVentas" icon="fa-file-invoice-dollar" label="Ventas" />
          </Row>
          <br />
          <Row>
            <Btn permitido={user.menu_ventas} href="/VentaDirectaCreate" icon="fa-cash-register" label="Venta Directa" />
            <Btn permitido={user.menu_devoluciones} href="/ListadoDevoluciones" icon="fa-undo-alt" label="Devoluciones" />
            <Btn permitido={user.notasCargo} href="/ListadoNotasCargo" icon="fa-money-check-alt" label="Notas de Cargo" />
          </Row>
            <br />
          <Row>
            <Btn permitido={user.menu_pedidos} href="/DashboardVentasTabla" icon="fa-list" label="Ventas Stock" />
            <Btn permitido={user.reporteArticulosVendidos} href="/ReporteArticulosSurtidos" icon="fa-chart-bar" label={<>Reporte Artículos<br />Vendidos</>} />
            <Btn permitido={user.menu_pedidos} href="/ReporteVentasCotizaciones" icon="fa-file-invoice" label={<>Ventas y<br />Cotizaciones</>} />
          </Row>
            <br />
          <Row>
            <Btn permitido={user.menu_admin} href="/ReporteUtilidades" icon="fa-coins" label="Reporte Utilidades" />
            <Btn permitido={user.menu_admin} href="/ReporteUtilidadesMensual" icon="fa-calendar-alt" label={<>Utilidades<br />por Mes</>} />
          </Row>

          {/* ===== CUENTAS ===== Menu Admin, o quien tenga el permiso de alguno de
              sus botones (Estado de Cuenta / Abonos) sin ser vendedor: antes sólo
              Menu Admin, y el personal de oficina con esos permisos no llegaba.
              Los vendedores tienen su propia sección de Estado de Cuenta abajo. */}
          {(user.menu_admin || ((user.edoCtaClientes || user.abonos) && user.vendedor !== "Si")) && (
            <>
              <Seccion titulo="Cuentas" />
              <Row>
                <Btn permitido={user.edoCtaClientes} href="/EstadoCuenta" icon="fa-file-invoice-dollar" label="Estado Cuenta" />
                <Btn permitido={user.abonos} href="/AntiguedadSaldosVencido" icon="fa-dollar-sign" label="Antiguedad Saldos" />
                <Btn permitido={user.abonos} href="/CobranzaVendedor" icon="fa-hand-holding-usd" label="Cobranza Vendedor" />
                {/* <Btn permitido={user.abonos} href="/ListadoAbonosGeneral" icon="fa-dollar-sign" label="Reporte Ingresos" /> */}
              </Row>
            </>
          )}
          
          {/* ===== CATÁLOGOS ===== */}
          <Seccion titulo="Catálogos" />
          <Row>
            <Btn permitido={user.menu_clientes} href="/Clientes" icon="fa-user-tie" label="Clientes" />
            <Btn permitido={user.menu_articulos} href="/Paqueterias" icon="fa-shipping-fast" label="Paqueterias" />
          </Row>

          {/* ===== SURTIDOS ===== */}
          {/* <Seccion titulo="Surtidos" />
          <Row>
            <Btn permitido={user.menu_surtidos} href="/ListoSurtir" icon="fa-dolly" label="Listo Surtir" />
            <Btn permitido={user.menu_surtidos} href="/ListoSurtirCliente" icon="fa-dolly-flatbed" label="Listo Surtir Clientes" />
            <Btn permitido={user.menu_surtidos} href="/ReporteSurtidos" icon="fa-clipboard-list" label="Reporte Surtidos" />
          </Row> */}

          {/* ===== ANÁLISIS ===== */}
         {/* <Seccion titulo="Análisis" />
           <Row>
            <Btn permitido={user.menu_ventas} href="/AnalisisArticulosPedidos" icon="fa-search" label="Análisis Cotizaciones" />
            <Btn permitido={user.menu_surtidos} href="/AnalisisArticulosPedidosExpo" icon="fa-list" label="Artículos Cotizaciones" />
            <Btn permitido={user.menu_surtidos} href="/AnalisisArticulosPedidosGlobal" icon="fa-globe" label="Artículos Cotizaciones Global" />
          </Row>
          <br />
          <Row>
            <Btn permitido={user.menu_devoluciones} href="/AnalisisArticulosDevoluciones" icon="fa-chart-line" label="Artículos Devoluciones" />
          </Row> */}

          {/* ===== REPORTES DE PRECIOS ===== */}
         {/* <Seccion titulo="Reportes de Precios" />
           <Row>
            <Btn permitido={user.menu_ventas} href="/ReporteUltimoPrecio" icon="fa-dollar-sign" label="Último Precio Cliente" />
            <Btn permitido={user.menu_ventas} href="/ReporteUltimoPrecioArticulo" icon="fa-tshirt" label="Último Precio Artículo" />
            <Btn permitido={user.menu_surtidos} href="/ReportePrecios" icon="fa-tag" label="Reporte Precios" />
          </Row> */}

          {/* ===== ESTADO DE CUENTA (solo vendedor) ===== */}
          {user.edoCtaClientes && user.vendedor === "Si" && (
            <>
              <Seccion titulo="Estado de Cuenta" />
              <Row>
                <Btn permitido={true} href="/EstadoCuenta" icon="fa-balance-scale" label="Estado Cuenta" />
              </Row>
            </>
          )}

          <br />
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default BotonesVentas;
